<div class="alert-wrapper" [class]="'alert-' + (type | lowercase)">
  <div class="d-flex">
    <div class="icon m-r-4 d-flex justify-content-center align-items-center">
      <i class="ri-"></i>
    </div>
    <div class="text">
      @if (title) {
        <span class="title" [class.m-r-4]="alertStyle === 'one-line'" [class.d-block]="alertStyle !== 'one-line'">
          {{ title }}
        </span>
      }

      <span class="message">
        @if (message) {
          {{ message }}
        }
        <ng-container *ngTemplateOutlet="additionalContent"></ng-container>
        <ng-content></ng-content>
      </span>
    </div>
  </div>
</div>
